export default __webpack_public_path__ + "static/media/white_refresh.04a2947d.svg";